import isUndefined from 'lodash/isUndefined'
import { areValidMimeTypes } from './mimeTypes'

export function validateRequired(value) {
  if (isUndefined(value) || value === null || !value.toString().length) {
    return 'This field is required.'
  }
  return true
}

export function validateRequiredFile(value) {
  if (value && [value].flat().length > 0) {
    return true
  }
  return 'File must be selected.'
}

export function validateFileMimeType(v) {
  return areValidMimeTypes(v) || 'Invalid file type.'
}

export function validateMinimumOf(
  minimum,
  message = `This field cannot be less than ${minimum}`
) {
  return (value) => {
    const numericValue = parseInt(value)
    return numericValue >= minimum || message
  }
}

export const validateNonNegative = validateMinimumOf(
  0,
  'This field must be zero or a positive number.'
)
